import { useState, useEffect } from "react";
import client from '../../utils/prismicHelpers';
import * as queries from "../../utils/prismicQueries";
import Emitter from "../../utils/emitter";
import SocialLinks from "./socialLinks";
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
function FullMenu() {
  const [toggled, setToggle] = useState(0);
  const [navLink, setNavLinks] = useState(null);
  const [showGovernanceBtn, setGovernanceBtn] = useState(false);
  const history = useNavigate();
  const navigate = useNavigate();

  useEffect(() => {
    Emitter.on("TOGGLE_MENU", (newValue) => setToggle(!toggled));
    client.query({
      query: queries.navInfo,
    })
      .then((response) => {
        const links = response.data.allNavbars.edges[0].node;
        setNavLinks(links);


      })
      .catch((error) => {
        console.error(error);
      });
  });

  function filterInt(value) {
    if (/^[-+]?(\d+)$/.test(value)) {
      return 1
    } else {
      return 0
    }
  }

  function moveSection(section) {
    // console.log(section)
    if (filterInt(section)) {
      // console.log("ISNAN")
      Emitter.emit("MOVE_SECTION", section);
      Emitter.emit("TOGGLE_MENU", section);
    } else {
      //  console.log("ISNOTNAN")
      history(section);
    }
  }
  function navToggle(route) {
    navigate(route)
    Emitter.emit('TOGGLE_MENU', 'TOGGLE');

  }

  return (
    <div className="FullView" style={{ height: toggled ? '100vh' : '0vh' }}>
      <div className="contentDiv">
        <ul>  {navLink?.nav_link?.map((link, index) =>
          <li key={index + 1}>
            <a
              key={Date.now() + Math.random() + Math.random()}
              className="text-decoration-none"
              href={filterInt(link?.section_number[0]?.text) ? `/#${link?.nav_link1[0]?.text}` : ``}>

              <span onClick={() => link?.section_number[0]?.text &&
                moveSection(link?.section_number[0]?.text)} >   {link?.nav_text} </span>

            </a>

            {link?.section_number[0]?.text == 2 ?
              <>
                <button className="btn outlineless-btn p-0 m-0" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
                  <FontAwesomeIcon
                    className="mx-2  nav-right-arrow"
                    onClick={() => setGovernanceBtn(!showGovernanceBtn)}
                    icon={!showGovernanceBtn ? faChevronDown : faChevronUp} />
                </button>
                <div
                  onClick={() => navToggle("/governance")}
                  className="collapse pt-2 m-0 colaps-text"
                  id="collapseExample"
                >
                  Governance body
                </div>
              </> : null
            }

          </li>
        )}
        </ul>

        <div className={`${toggled ? 'menuFooter d-flex justify-content-center' : 'd-none'}`}>
          <div className="top-socila-link">

            <SocialLinks />
          </div>
        </div>
      </div>
    </div>

  );
}

export default FullMenu;
